
import React from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import './App.css';
import Web from './components/pages/Web'

import UserDetails from './components/users/UserDetails';
import About from './components/pages/About';
import Login from './components/pages/Login';
import GlobalState from './context/global/globalState';
import Home from './components/pages/Home';
import NotFound from './components/pages/NotFound';
const App = () => {

    return (
        <GlobalState>
                <Router>

                    <Switch>
                        <Route exact path='/' component={Home} />
                        <Route exact path='/about' component={About} />
                        <Route exact path='/login' component={Login} />
                        <Route exact path='/user/:login' component={UserDetails} />
                        <Route component={NotFound} />
                    </Switch>
                </Router>
        </GlobalState>
    );
}

export default App;